import React, { useState, useEffect } from 'react';
import {LinkProps} from 'react-router-dom';
import { Container } from './styles';

interface ILinkProps extends LinkProps {
  variant?: "filled" | "outlined";
}

export interface IVariantStyleProps {
  background: string;
  color: string;
}

const Button: React.FC< ILinkProps> = ({variant = "filled", children, ...props}) => {
  const [variantStyle, setVariantStyle] = useState<IVariantStyleProps>({
    background: 'transparent',
    color: '#000',
  });

  useEffect(() => {
    let style: IVariantStyleProps;
    switch (variant) {
      case "filled":
        style = {
          background: "var(--primary)",
          color: "var(--primary-complementary-text-color)",
        };
        return setVariantStyle(style);
      case "outlined":
        style = {
          background: "transparent",
          color: "var(--secondary)",
        };
        return setVariantStyle(style);
      default:
        break;
    }
  }, [variant]);

  return (
    <Container {...variantStyle} {...props}>
      {children}
    </Container>
  );
}

export default Button;